import { createFileRoute, useParams } from "@tanstack/react-router";
import { useQuery } from "convex/react";
import { CircleNotch } from "@phosphor-icons/react";
import { api } from "@alfred/convex/_generated/api";
import { TicketDetail } from "~/components/TicketDetail";

export const Route = createFileRoute("/tickets/$key/")({
  component: TicketPage,
});

function TicketPage() {
  const { key } = useParams({ strict: false }) as { key: string };
  const ticket = useQuery(api.tickets.get, { jiraKey: key });
  if (ticket === undefined) {
    return (
      <div className="flex h-full items-center justify-center text-sm text-muted-foreground">
        <CircleNotch size={16} className="mr-2 animate-spin" /> Loading {key}…
      </div>
    );
  }
  if (ticket === null) {
    return (
      <div className="mx-auto max-w-2xl p-6">
        <h2 className="text-lg font-semibold">Ticket {key} not found</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          Alfred hasn't seen this ticket yet. Make sure it has the{" "}
          <code className="rounded bg-muted px-1 py-0.5 font-mono text-xs">
            alfred
          </code>{" "}
          label in Jira and trigger a sync.
        </p>
      </div>
    );
  }
  return <TicketDetail ticket={ticket} />;
}
